import startClient from 'coreReactRouter/entry.client';

import AppConfig from './components/_app-config';
import createQueryClient from './utils/createQueryClient';
import {fetchTranslations} from './utils/locale';

startClient({AppConfig, createQueryClient, fetchTranslations});
